import { connect } from 'react-redux';

//import { login } from '../../actions/CurrentAccount';
import { 
    closeMenu, 
    fetchNotifications, 
    ignoreReportUpdate, 
    ignoreSupportUpdate
} from '../../actions/UserMenu';

import UserMenu from '../../components/UserMenu/UserMenu';
import { ignoreModUpdate } from '../../actions/Followed';

const mapStateToProps = (state) => ({
    spaId: state.currentAccount.spaId,
    spaUsername: state.currentAccount.spaUsername,
    count: state.currentAccount.count,
    notifications: state.currentAccount.notifications,
    isFetching: state.currentAccount.isFetching,

    isOpened: state.userMenu.isOpened,
})

const mapDispatchToProps = (dispatch) => ({
    /*onLoginClick() {
        //dispatch(login())
    },*/
    onCloseMenu() {
        dispatch(closeMenu())
    },
    fetchNotifications(userData) {
        dispatch(fetchNotifications(userData))
    },
    onChangeNotifyActive(userData) {
        //dispatch(onChangeNotifyActive(userData))
    },

    onIgnoreNotify: (objectId, userData, type) => { // type=0 - all for site, 1 - following, 2 - reports, 3 - support
        if (type === 1) {
            Promise.resolve(
                dispatch(ignoreModUpdate(objectId, userData, objectId))
            ).then(() => dispatch(fetchNotifications(userData)))
        } else if (type === 2) {
            Promise.resolve(
                dispatch(ignoreReportUpdate(objectId, userData, objectId))
            ).then(() => dispatch(fetchNotifications(userData)))
        } else if (type === 3) {
            Promise.resolve(
                dispatch(ignoreSupportUpdate(objectId, userData, objectId))
            ).then(() => dispatch(fetchNotifications(userData)))
        } else {
            dispatch(fetchNotifications(userData))
        }
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu)
